import axios from 'axios';

const getAllPriorYearItemsMatches = year =>
  axios.get(
    `/prior_year_items_matches/get_all_prior_year_items_matches?year=${year}`,
  );

const updatePriorYearItemsMatch = ({ id, ...rest }) =>
  axios.patch(`/prior_year_items_matches/${id}`, {
    ...rest,
  });

const deletePriorYearItemsMatch = id =>
  axios.delete(`/prior_year_items_matches/${id}/delete_prior_year_items_match`);

const deletePriorYearItem = ({ id, priorYearItemId }) =>
  axios.delete(
    `/prior_year_items_matches/${id}/delete_prior_year_item?prior_year_item_id=${priorYearItemId}`,
  );

const matchToEntities = ids =>
  axios.post('/prior_year_items_matches/match_to_entities', {
    ids,
  });

const addPriorYearItem = ({ itemName, id }) =>
  axios.post(`/prior_year_items_matches/${id}/add_prior_year_item`, {
    item_name: itemName,
  });

const loadItemsForPriorYearItemsMatch = id =>
  axios.get(`/prior_year_items_matches/${id}/get_prior_year_items`);

const getPriorYearDocumentsStatus = year =>
  axios.post(`/prior_year_items_matches/get_prior_year_documents_status`, {
    year,
  });

const reRunRolloverItemsReader = year =>
  axios.post(`/prior_year_items_matches/re_run_rollover_items_reader`, {
    year,
  });

const removeAllUploadedFilesForRolloverItems = year =>
  axios.post(
    `/prior_year_items_matches/remove_all_uploaded_files_for_rollover_items`,
    {
      year,
    },
  );

export default {
  getAllPriorYearItemsMatches,
  updatePriorYearItemsMatch,
  deletePriorYearItemsMatch,
  deletePriorYearItem,
  matchToEntities,
  addPriorYearItem,
  loadItemsForPriorYearItemsMatch,
  getPriorYearDocumentsStatus,
  reRunRolloverItemsReader,
  removeAllUploadedFilesForRolloverItems,
};
